import dynamic from 'next/dynamic'
import { DemographicsIcon } from 'src/components/insights/icons/demographics'
import { InsightBuilderWidget } from 'src/types/insight-builder'
import preview from 'src/assets/images/widgets-previews/types-of-housing-units.png'

const DemographicsTypesHousingUnits = dynamic(
  () => import('src/components/insights/demographics/cards/types-housing-units'),
  {
    ssr: false,
  }
)

export const DemographicsTypesHousingUnitsWidget: InsightBuilderWidget = {
  id: 'types-of-housing-units',
  name: 'Types of Housing Units',
  type: 'Demographics',
  icon: DemographicsIcon,
  component: DemographicsTypesHousingUnits,
  supportedResultTypes: ['alphamap-location'],
  preview,
}
